import React from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import ApiService from '../../../../service/apiService';
import logUtils from '../../../../HelperMethods/LogUtils';

export default function InstructionsSegment({ taskType }) {
  const [instructions, setInstructions] = React.useState([]);
  React.useEffect(() => {
    async function fetchData() {
      setInstructions([]);
      if (taskType?.originalobject?.instructionIds?.length > 0) {
        try {
          const instructionsDB = await ApiService.getEntitiesByIds(
            taskType.originalobject.instructionIds,
            'instruction'
          );
          setInstructions(instructionsDB.filter((a) => !a.isDeleted));
        } catch (e) {
          logUtils.logError(e, 'Instrucitons Loading Failed');
        }
      }
    }
    fetchData();
  }, [taskType]);
  if (!instructions?.length) return null;
  return (
    <Segment style={{ border: '1px solid #e5e5e5', marginTop: '10px' }}>
      <Grid>
        <Grid.Row className="form-group-header">Special Instructions</Grid.Row>

        <Grid.Row style={{ marginLeft: '5px' }}>
          <Grid.Column width={16}>
            <Grid style={{ marginTop: '0px', marginBottom: '0px', paddingLeft: '10px' }}>
              <Grid.Row>
                {instructions.map((item, index) => {
                  return (
                    <Grid.Column
                      key={index}
                      width={10}
                      style={{
                        padding: '10px',
                        borderRadius: '4px',
                        backgroundColor: '#f6f6f6',
                        color: '#2d2d2d',
                        fontSize: '12px',
                        marginBottom: '10px',
                        overflowWrap: 'break-word',
                      }}
                    >
                      <pre
                        style={{ padding: '0px', fontFamily: 'JoynFontBook', margin: '0px', whiteSpace: 'pre-line' }}
                      >
                        {`${item.text}`}
                      </pre>
                    </Grid.Column>
                  );
                })}
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
